import { render, staticRenderFns } from "./V2ProductDetailContent.vue?vue&type=template&id=c57fac1c&scoped=true&"
import script from "./V2ProductDetailContent.vue?vue&type=script&lang=js&"
export * from "./V2ProductDetailContent.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductDetailContent.vue?vue&type=style&index=0&id=c57fac1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57fac1c",
  null
  
)

export default component.exports